//colors
export const colors = [
	'#009900',
	'#FF3131',
	//'var(--accent50)',
	// 'var(--base40)',
];
